// import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'
export default {
  inserted(el, binding, vnode) {
    const target = el.querySelector('.el-table__body-wrapper');
    target.addEventListener('scroll', (e) => {
      const scrollTop = target.scrollTop;
      const offsetHeight = target.offsetHeight;
      const scrollHeight = target.scrollHeight;
      if (scrollTop + offsetHeight >= scrollHeight) {
        binding.value.fn();
      }
    });
  }
};
